import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, setDoc, collection, query, where, getDocs, limit, getDoc, increment, Timestamp } from 'firebase/firestore';
import { motion } from 'framer-motion';
import { db } from '../App';
import './SignUp.css';

const SignUp = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const getNextMembershipNumber = async () => {
    const membershipCounterRef = doc(db, 'counters', 'membershipNumber');
    const membershipCounterDoc = await getDoc(membershipCounterRef);
    if (membershipCounterDoc.exists()) {
      const currentNumber = membershipCounterDoc.data().count;
      await setDoc(membershipCounterRef, { count: increment(1) }, { merge: true });
      return currentNumber + 1;
    } else {
      await setDoc(membershipCounterRef, { count: 1 });
      return 1;
    }
  };

  const handleGoogleSignUp = async () => {
    setIsLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('email', '==', user.email), limit(1));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        const membershipNumber = await getNextMembershipNumber();
        await setDoc(doc(db, 'users', user.uid), {
          name: user.displayName || 'New User',
          email: user.email.toLowerCase(),
          createdAt: new Date(),
          money: 25,
          tokens: 0,
          authorized: true,
          bio: '',
          profilePicture: user.photoURL || 'https://t3.ftcdn.net/jpg/08/05/28/22/240_F_805282248_LHUxw7t2pnQ7x8lFEsS2IZgK8IGFXePS.jpg',
          status: "Hey, I'm new!",
          gamesPlayed: 0,
          membershipNumber,
          membershipStatus: 'Bronze',
          lastDailyReward: Timestamp.now()
        });
        setSuccess('Account created successfully with Google.');
        
        setTimeout(() => {
          navigate('/portal');
        }, 2000);
      } else {
        setError('An account with this email already exists.');
      }
    } catch (error) {
      console.error('Error during Google sign up:', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="signup-page"
    >
      <div className="signup-container">
        <h1 className="signup-title">Join Us</h1>
        <button onClick={handleGoogleSignUp} className="google-signup-button" disabled={isLoading}>
          {isLoading ? 'Signing Up...' : 'Sign Up with Google'}
        </button>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
      </div>
    </motion.div>
  );
};

export default SignUp;